export default __webpack_public_path__ + "static/media/bam_pow.3482422a.svg";